export const candidateResultColumnsConfig = {
    ID:"Candidate Id",
    NAME: "Name",
    EMAIL: "Email",
    MOBILE:"Mobile",  
    TOTQUESTION:"Total Question",
    CORRECTANS:"Corrrect Answer",
    RESULT_RULE:"Result Rule",
    SCORE:"Score",
    STATUS:"Status",
    ACTION:"Actions"

  };